import React from 'react';
import { Message } from 'semantic-ui-react';
import Head from 'next/head';
import { i18n, withNamespaces, Link } from '../i18n';

const Contact = ({ t }) => {
	return (
		<div>
			<Head>
				<title>CollectAPI - {t('contact_us')}</title>
			</Head>
			<div className="contact">
				<Message
					floating
					compact
					size="huge"
					className="contact-message"
					style={{
						background: 'white',
					}}
				>
					<Message.Header>{t('contact_us')}</Message.Header>
					<p>{t('contact_us1')}</p>
					<h3>{t('address')}</h3>
					<p>Ataşehir, İstanbul</p>
					<p>
						<br />
						E-mail: <a href="mailto:info@collectapi.com">info@collectapi.com</a>
					</p>
				</Message>
			</div>
		</div>
	);
};

Contact.getInitialProps = async () => {
	return { namespacesRequired: ['common'] };
};

export default withNamespaces()(Contact);
